import { createFileRoute } from "@tanstack/react-router";

import { AGENT_ROLES, AuthGuard } from "@/lib/auth";
import { AuditPage } from "@/features/admin/pages/audit-page";

export const Route = createFileRoute("/_authenticated/admin/audit/")({
	component: AuditRouteComponent,
});

function AuditRouteComponent() {
	return (
		<AuthGuard requiredRole={AGENT_ROLES.ADMIN}>
			<AuditPage />
		</AuthGuard>
	);
}
